import React, { useMemo, useReducer, useState } from 'react';
import { Icon } from 'antd';
import DspxPopover from '../../../../../components/DspxPopover/DspxPopover';
import Btn, { btnTypes } from '../../../../../components/btn';
import { ReactComponent as SettingIcon } from '../../../../../resource/SettingsIcon.svg';
import styles from './index.module.scss';

const FilterBtn = ({
  renderContent,
  expanded = false,
  placement = 'bottomLeft',
  isActive = false,
  disabled = false,
}) => {
  const [visible, setVisible] = useState(false);
  const [contentKey, resetContent] = useReducer((x) => x + 1, 0);

  const handleVisibleChange = (visible) => {
    if (disabled) {
      return;
    }

    setVisible(visible);
    if (!visible) {
      resetContent();
    }
  };

  const content = useMemo(
    () => renderContent({ onClose: () => setVisible(false) }),
    [renderContent]
  );

  return (
    <DspxPopover
      key={contentKey}
      visible={visible}
      onVisibleChange={handleVisibleChange}
      content={content}
      arrow={false}
      trigger="click"
      placement={placement}
      overlayClassName={styles.root}
    >
      <Btn
        className={styles.btn}
        disabled={disabled}
        type={isActive ? btnTypes.primary : btnTypes.secondary}
      >
        {expanded ? `Фильтрация ` : null}
        <Icon component={SettingIcon} className={styles.icon} />
      </Btn>
    </DspxPopover>
  );
};

export default FilterBtn;
